module.exports = __webpack_public_path__ + "images/7076318.png";